import { Text } from '@mntn/ui-components'
import { ProgramCard } from '@/components/shared'
import type { OrderItem } from '@/flight-deck-api/services/order-items.service'

interface Props {
  programs: OrderItem['programs']
  description: string
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const OfferingDetailSection: React.FC<Props> = ({ programs, description }) => {
  return (
    <div>
      <Text variant="h4">Deal Details</Text>
      <Text variant="base-sm" className="text-secondary">
        {description}
      </Text>
      <div className="self-stretch py-4 inline-flex justify-start items-start gap-2 flex-wrap content-start">
        {programs.map(program => (
          <ProgramCard
            key={program.programId}
            imageProps={{
              src: program.artwork.croppedUrl,
              alt: program.programName,
            }}
            size="lg"
            networkName={program.network.name}
            programName={program.programName}
          />
        ))}
      </div>
    </div>
  )
}
